import { ISubstate } from "../../interfaces";

export const SubstateEmpty: ISubstate = {
    id: "",
    name: "",
    state: "",
    abbreviation: "",
    _ts: 0
}